import styled from 'styled-components'
import { device } from '../../styles/Breakpoints'
import { Container } from '../../styles/Wrappers'

export const WorkableContainer = styled(Container)`
	& > h2 {
		padding-bottom: 0.5em;
	}

	.whr-group {
		font-size: 26px;
	}

	.whr-date,
	.whr-code {
		display: none;
	}

	@media ${device.sm} {
		.whr-group {
			font-size: 30px;
		}
	}
`
